import { LazyImageFillMode, LazyImageScope, QpLazyImageAttribute } from "./qp-lazy-image.types";
import tpl from "./qp-lazy-image.template.html"
import IMAGE_BROKEN from "./assets/images/image_broken.svg";

//-----------------------------------------------------
// SECTION - 1. QpLazyImage指令构造函数
//-----------------------------------------------------
export function QpLazyImage($timeout: angular.ITimeoutService, $sce: angular.ISCEService): ng.IDirective {
    return {
        restrict: 'E',
        template: tpl,
        transclude: true,
        scope: {
            imageSrc: '@',// 字符函数
            lazyDelay: '@',
            placeholder: '@',
            fallback: '@',
            errorTitle: '@',
            retryTimes: '@',
            fillMode: '@',
            allowReload: '=',
            onLoad: '&',       // 绑定函数
            onError: '&',       // 绑定函数
            onRetry: '&',     // 绑定函数
            onReload: '&'     // 绑定函数
        },
        link: (scope: LazyImageScope,
            elements: JQLite,
            attributes: QpLazyImageAttribute,
            ctrl?: angular.IController,
            transcludeFn?: angular.ITranscludeFunction): void => {

            //-----------------------------------------------------
            // SECTION - 1.1 变量声明部份
            //-----------------------------------------------------

            //目标图片
            let imageUrl: string = attributes.src;
            //懒加载
            let lazyDelay: number = attributes.lazyDelay ?? 500;
            //重试次数
            let retryTimes = attributes.retryTimes;
            //图片元素
            let imageObj: HTMLImageElement | null = null;
            //占位符图片
            let placeholderImage: HTMLImageElement | null = null;

            //初始化transclude传输内容
            let transContents = transcludeFn != undefined ? elements.children() : undefined;
            let promises = new Array<angular.IPromise<any>>();

            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------

            //-----------------------------------------------------
            // SECTION - 1.2 加载功能函数
            //-----------------------------------------------------
            /**
             * 加载功能
             * @param event 
             */
            let onLoadFn = function (event: Event) {
                // console.log("start onLoadFn, %s",  scope.$id);

                if (event && event.target) {
                    setFillMode(imageObj!, attributes.fillMode);

                    appendContent(imageObj!);

                    $timeout(() => {
                        if (scope.onLoad) {
                            // console.log("start scope.onLoad, %s",  scope.$id);

                            let args = { url: imageUrl, image: imageObj!, event: event };
                            scope.onLoad({ elements: elements, scope: scope, result: args });

                            // console.log("end scope.onLoad, %s",  scope.$id);
                        }
                    });
                } else {
                    onErrorFn(event);
                }

                // console.log("end onLoadFn, %s",  scope.$id);
            };
            //-----------------------------------------------------
            // !SECTION 
            //-----------------------------------------------------

            // let observerFn = function () {

            // }


            let appendContent = function (objs: JQuery | any[] | Element | DocumentFragment | Text | string) {
                // let imageContainer = elements.children("div");

                // if (imageContainer) {
                // imageContainer.empty()
                // imageContainer.append(obj)
                // }

                elements.empty();
                elements.append(objs);
            }

            //-----------------------------------------------------
            // SECTION - 1.3 加载错误处理函数
            //-----------------------------------------------------
            /**
             * 加载错误
             * @param event 
             * @param source 
             */
            let onErrorFn = function (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) {

                // console.log("start onErrorFn, %s",  scope.$id);

                if (retryTimes !== undefined && retryTimes > 0) {
                    $timeout(() => {
                        if (scope.onRetry) {
                            let state = { times: attributes.retryTimes! - retryTimes! + 1, url: imageUrl, cancle: clearFn };
                            scope.onRetry({ elements: elements, scope: scope, state: state });
                        }

                        retryTimes = retryTimes! - 1;
                        imageObj = createImage(imageUrl, lazyDelay, onLoadFn, onErrorFn);
                    });
                } else {
                    $timeout(() => {
                        if (scope.onError) {
                            let reason = { error: error, event: event }
                            scope.onError({ elements: elements, scope: scope, reason: reason });
                        }

                        createErrorImage();
                    });
                }

                // console.log("end onErrorFn, %s",  scope.$id);
            }
            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------


            //-----------------------------------------------------
            // SECTION - 1.4 清除调用图片对象
            //-----------------------------------------------------

            let clearFn = function () {
                if (promises.length > 0) {
                    for (let i = 0; i < promises.length; i++) {
                        const promise = promises[i];
                        $timeout.cancel(promise);
                    }

                    promises = [];
                }

                if (placeholderImage != null) {
                    placeholderImage.src = "";
                    placeholderImage = null;
                }

                if (imageObj != null) {
                    imageObj.removeEventListener("load", onLoadFn);
                    imageObj.removeEventListener("error", onErrorFn);
                    imageObj.src = "";
                    imageObj = null
                }
            }
            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------


            //-----------------------------------------------------
            // SECTION - 1.4 初次加载组件
            //-----------------------------------------------------


            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------

            //-----------------------------------------------------
            // SECTION - 1.5 加载新的图片
            //-----------------------------------------------------
            /**
             * 加载新的图片
             * @param url 
             */
            let loadNewImageFn = function (url: string) {
                // console.log("start loadNewImageFn, %s , %s", url, scope.$id);

                //移除旧的上下文
                clearFn();
                createPlaceholder();

                //初始化上下文数据
                imageUrl = url;
                retryTimes = attributes.retryTimes;

                imageObj = createImage(url, lazyDelay, onLoadFn, onErrorFn);
                elements.removeAttr("title");

                // console.log("end loadNewImageFn, %s , %s", url, scope.$id);
            }
            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------

            //-----------------------------------------------------
            // SECTION - 1.6 创建图片元素
            //-----------------------------------------------------
            /**
             * 创建图片元素
             * @param url 
             * @param loadFn 
             * @param errorFn 
             * @returns 
             */
            let createImage = function (url: string, delay: number = 0, loadFn?: (event: Event) => void, errorFn?: OnErrorEventHandler): HTMLImageElement {
                let imgObj = new Image();
                imgObj.crossOrigin = 'anonymous';

                if (loadFn) {
                    imgObj.onload = loadFn;
                }

                if (errorFn) {
                    imgObj.onerror = errorFn;
                }

                if (delay > 0) {
                    let p = $timeout(() => {
                        imgObj.src = url;
                    }, delay);

                    promises.push(p);
                } else {
                    imgObj.src = url;
                }

                return imgObj;
            }

            let createErrorImage = function () {
                // console.time("createErrorImage");

                //错误加载图
                let errorImageUrl: string = attributes.fallback ?? IMAGE_BROKEN;
                //是否可以重试
                let allowReload: boolean = attributes.allowReload == undefined ? true : attributes.allowReload;

                let missingImage = createImage(errorImageUrl);

                if (allowReload === true || String(allowReload) == "true") {
                    $(missingImage).addClass("error-image");
                }

                if (attributes.errorTitle) {
                    $(missingImage).attr("title", attributes.errorTitle)
                }

                if (errorImageUrl != IMAGE_BROKEN) {
                    setFillMode(missingImage, attributes.fillMode);
                } else {
                    setFillMode(missingImage);
                }

                appendContent(missingImage);

                if (allowReload === true || String(allowReload) == "true") {
                    $(missingImage).on("click tap", function () {
                        $timeout(() => {
                            if (scope.onReload) {
                                scope.onReload({ elements: elements, scope: scope });
                            }

                            loadNewImageFn(imageUrl);
                        });
                    });
                }

                // console.timeEnd("createErrorImage")
            }

            let createPlaceholder = function () {
                //默认图
                let placeholder = attributes.placeholder;
                // 创建空白占位标签
                let placeholderTage = document.createElement('div');
                placeholderTage.className = 'placeholder-tage-skeleton';

                if (placeholder && placeholder != "") {
                    if (transContents) {
                        appendContent(transContents);
                    } else {
                        //空白占位
                        appendContent(placeholderTage);
                    }

                    placeholderImage = createImage(placeholder, 100, (event) => {
                        if (placeholderImage) {
                            setFillMode(placeholderImage, attributes.fillMode);
                            appendContent(placeholderImage);
                        } else {
                            //空白占位
                            appendContent(placeholderTage);
                        }
                    });

                } else if (transContents) {
                    appendContent(transContents);
                }
                else {
                    //空白占位
                    appendContent(placeholderTage);
                }
            }

            let setFillMode = function (imageElement: HTMLImageElement, fillMode: LazyImageFillMode = "Contain") {
                let $image = $(imageElement);

                if (fillMode.toLowerCase() == "crop") {
                    $image.css("object-fit", "cover");
                } else if (fillMode.toLowerCase() == "fill") {
                    $image.css("object-fit", "fill");
                } else if (fillMode.toLowerCase() == "none") {
                    $image.css("object-fit", "none");
                } else {
                    $image.css("object-fit", "contain");
                }
            }

            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------

            //-----------------------------------------------------
            // SECTION - 1.7 监听属性变化
            //-----------------------------------------------------

            let firstLoad = true;

            scope.$watch(function () {
                return attributes.imageSrc;
            }, function (newValue: string, oldValue: string) {
                if (newValue && newValue != "" && (firstLoad || newValue != oldValue)) {
                    $timeout(() => {
                        loadNewImageFn(newValue);
                    }, 100);
                    firstLoad = false;
                }

                return newValue;
            });

            scope.$on('$destroy', function () {
                clearFn();
            });

            //-----------------------------------------------------
            // !SECTION
            //-----------------------------------------------------
        }
    };
}
//-----------------------------------------------------
// !SECTION
//-----------------------------------------------------


//-----------------------------------------------------
// SECTION - 2. QpLazyImage指令注入
//-----------------------------------------------------
QpLazyImage.$inject = ["$timeout", "$sce"];
//-----------------------------------------------------
// !SECTION
//-----------------------------------------------------